import {Sequence, SequenceElement, SequenceInputResponse, Node as SomatNode} from "@/types/models";

export type NodeAction =
    | { type: 'SET', nodes: SomatNode[] }
    | { type: 'ADD_ARRAY_NODE', node: SomatNode }
    | { type: 'REMOVE_ARRAY_NODE', node: SomatNode }
    | { type: 'ADD_SEQUENCE'; node: SomatNode; sequence: Sequence }
    | { type: 'REMOVE_SEQUENCE'; node: SomatNode; sequenceId: number }
    | { type: 'UPDATE_SEQUENCE'; node: SomatNode; sequence: Sequence }
    | { type: 'ADD_SEQUENCE_ELEMENT'; node: SomatNode; sequence: Sequence; element: SequenceElement }
    | { type: 'REMOVE_SEQUENCE_ELEMENT'; node: SomatNode; sequence: Sequence; elementId: number }
    | { type: 'SET_SEQUENCE_INPUT_RESPONSE'; node: SomatNode; sequence: Sequence; element: SequenceElement; response: SequenceInputResponse }

export function nodeReducer(nodes: SomatNode[], action: NodeAction) {
    switch(action.type) {
        case 'SET':
            return action.nodes

        case 'ADD_SEQUENCE':
            return nodes.map(n => n.id === action.node.id && n.array_index === action.node.array_index && n.parent_array_index === action.node.parent_array_index ? {...n, sequences: [...n.sequences ?? [], action.sequence]} : n)

        case 'REMOVE_SEQUENCE':
            return nodes.map(n => n.id === action.node.id && n.array_index === action.node.array_index && n.parent_array_index === action.node.parent_array_index ? { ...n, sequences: n.sequences?.filter(s => s.id !== action.sequenceId) } : n)

        case 'UPDATE_SEQUENCE':
            return nodes.map(n => n.id === action.node.id && n.array_index === action.node.array_index && n.parent_array_index === action.node.parent_array_index ? { ...n, sequences: n.sequences?.map(s => s.id === 0 || s.id === action.sequence.id ? action.sequence : s) } : n)

        case 'ADD_SEQUENCE_ELEMENT':
            return nodes.map(n => n.id === action.node.id && n.array_index === action.node.array_index && n.parent_array_index === action.node.parent_array_index ? { ...n, sequences: n.sequences?.map(s => s.id === action.sequence.id ? { ...s, elements: [...s.elements ?? [], action.element] } : s) } : n)

        case 'REMOVE_SEQUENCE_ELEMENT':
            return nodes.map(n => n.id === action.node.id && n.array_index === action.node.array_index && n.parent_array_index === action.node.parent_array_index ? { ...n, sequences: n.sequences?.map(s => s.id === action.sequence.id ? { ...s, elements: s.elements?.filter(e => e.id !== action.elementId)} : s) } : n)

        case 'SET_SEQUENCE_INPUT_RESPONSE':
            return nodes.map(n => n.id === action.node.id && n.array_index === action.node.array_index && n.parent_array_index === action.node.parent_array_index
                ? { ...n, sequences: n.sequences?.map(s => s.id === action.sequence.id
                        ? { ...s, elements: s.elements?.map(e => e.id === action.element.id
                                ? { ...e, responses: action.response.id && e.responses?.find(r => r.sequence_input_id === action.response.sequence_input_id)
                                        ? e.responses?.map(r => r.sequence_input_id === action.response.sequence_input_id ? {...r, ...action.response} : r)
                                        : [...e.responses ?? [], action.response]
                        }
                                : e
                            )}
                        : s
                    )}
                : n
            )

        default:
            return nodes
    }
}
